import { FC } from 'react'
import { Paper, PaperProps, useTheme } from '@mui/material'

enum ExtendedVariants {
  muted,
  mutedLight,
  litblue,
  success,
  successLight,
  errorLight,
  error,
  warning,
  warningLight,
}
enum BaseVariants {
  outlined,
  elevation,
}
type ExtendedVariant = keyof typeof ExtendedVariants
type BaseVariant = keyof typeof BaseVariants
export interface ColoredPaperProps extends Omit<PaperProps, 'variant'> {
  color?: string
  backgroundColor?: string
  variant?: BaseVariant | ExtendedVariant
}
export const ColoredPaper: FC<ColoredPaperProps> = ({
  color,
  backgroundColor,
  variant = '',
  ...props
}) => {
  const theme = useTheme()

  // eslint-disable-next-line
  const variants: any = {
    muted: {
      color: '#000000',
      backgroundColor: theme.palette.muted,
    },
    mutedLight: {
      color: '#000000',
      backgroundColor: theme.palette.muted.light,
    },
    ltblue: {
      color: '#000000',
      backgroundColor: theme.palette.ltblue.main,
    },
    success: {
      color: '#FFF',
      backgroundColor: theme.palette.success.dark,
    },
    successLight: {
      color: theme.palette.success.dark,
      backgroundColor: theme.palette.success.faded,
    },
    error: {
      color: '#FFF',
      backgroundColor: theme.palette.error.dark,
    },
    errorLight: {
      color: theme.palette.error.dark,
      backgroundColor: theme.palette.error.faded,
    },
    warning: {
      color: '#FFF',
      backgroundColor: theme.palette.warning.dark,
    },
    warningLight: {
      color: theme.palette.warning.dark,
      backgroundColor: theme.palette.warning.faded,
    },
  }

  return (
    <Paper
      {...props}
      sx={{
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        color: color || variants[variant]?.color,
        backgroundColor: backgroundColor || variants[variant]?.backgroundColor,
        boxShadow: theme.shadows[props?.elevation as number],
        ...props.sx,
      }}
    />
  )
}

export default ColoredPaper
